import { render, staticRenderFns } from "./AccionPanelSolicitante.vue?vue&type=template&id=47474e40&scoped=true&"
import script from "./AccionPanelSolicitante.vue?vue&type=script&lang=js&"
export * from "./AccionPanelSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47474e40",
  null
  
)

export default component.exports